"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NEEDLESS_CONTACT_SURFACES = exports.CONTACT_SURFACES = exports.NEED_ACTION_CRM_SURFACES = exports.LEGACY_NEED_ACTION_SURFACE = exports.NEED_CONTACT_ROUTE_SURFACES = exports.WEEKLY_CONTACT_CAP = exports.CONTACT_CAP_WINDOW_DAYS = exports.RECENT_CONTACT_BLOCK_HOURS = exports.WORKER_CONTACT_RETENTION_DAYS = void 0;
const lib_custom_types_1 = require("@backend/lib-custom-types");
exports.WORKER_CONTACT_RETENTION_DAYS = 14;
exports.RECENT_CONTACT_BLOCK_HOURS = 24;
exports.CONTACT_CAP_WINDOW_DAYS = 7;
exports.WEEKLY_CONTACT_CAP = 3;
exports.NEED_CONTACT_ROUTE_SURFACES = (0, lib_custom_types_1.strictUnionArray)()([
    'NEED_CONSOLE',
    'CROSS_NEEDS_VIEW',
]);
exports.LEGACY_NEED_ACTION_SURFACE = 'NEED_CONSOLE';
exports.NEED_ACTION_CRM_SURFACES = (0, lib_custom_types_1.strictUnionArray)()([
    ...exports.NEED_CONTACT_ROUTE_SURFACES,
    'NEED_WORKER_QUALIF',
]);
exports.CONTACT_SURFACES = (0, lib_custom_types_1.strictUnionArray)()([
    ...exports.NEED_ACTION_CRM_SURFACES,
    'APPLICATIONS_CONSOLE',
    'WORKER_PROFILE',
]);
exports.NEEDLESS_CONTACT_SURFACES = (0, lib_custom_types_1.strictUnionArray)()([
    'APPLICATIONS_CONSOLE',
    'WORKER_PROFILE',
]);
